import React from 'react';
import { Table, Segment, Label, Image } from 'semantic-ui-react';
import Media from 'react-media';
import PropTypes from 'prop-types';
import TrackResultRow from './TrackResultRow';
import { SERVICE_DETAILS } from '../const/serviceDetails';

const TrackResultTable = ({ serviceName, trackingResults }) => (
  <>
    <Segment className={serviceName} raised>
      <Label ribbon>
        <Image
          className="service-logo"
          as="a"
          target="_blank"
          src={SERVICE_DETAILS[serviceName].logo}
          href={SERVICE_DETAILS[serviceName].url}
        />
      </Label>
      <Table celled padded>
        <Media
          query="(min-width: 768px)"
          render={() => (
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Poruka</Table.HeaderCell>
                <Table.HeaderCell>Lokacija</Table.HeaderCell>
                <Table.HeaderCell>Datum</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
          )}
        />
        <Table.Body>
          {trackingResults.map((trackingResult, $index) => (
            <TrackResultRow trackingResult={trackingResult} key={$index} />
          ))}
        </Table.Body>
      </Table>
    </Segment>
  </>
);

TrackResultTable.propTypes = {
  serviceName: PropTypes.string.isRequired,
  trackingResults: PropTypes.array.isRequired,
};

export default TrackResultTable;
